"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeclarableCadToolSchema = exports.CadToolSchema = void 0;
exports.getSupportedCadToolDisplayNames = getSupportedCadToolDisplayNames;
const zod_1 = require("zod");
exports.CadToolSchema = zod_1.z.enum([
    'kicad',
    'eagle',
    'altium',
    'orcad',
    'allegro',
    'xpedition',
    'cadstrom',
]);
exports.DeclarableCadToolSchema = exports.CadToolSchema.exclude(['cadstrom']);
const CAD_TOOL_DISPLAY_NAMES = {
    kicad: 'KiCad',
    eagle: 'Eagle',
    altium: 'Altium',
    orcad: 'OrCAD',
    allegro: 'Allegro X System Capture',
    xpedition: 'Xpedition',
    cadstrom: 'Cadstrom',
};
function getSupportedCadToolDisplayNames() {
    return exports.CadToolSchema.options.filter((tool) => tool !== 'cadstrom').map((tool) => CAD_TOOL_DISPLAY_NAMES[tool]);
}
//# sourceMappingURL=CadTool.js.map